import { render, staticRenderFns } from "./OrganizationHealthRow.vue?vue&type=template&id=5dd1447c&scoped=true"
import script from "./OrganizationHealthRow.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationHealthRow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationHealthRow.vue?vue&type=style&index=0&id=5dd1447c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd1447c",
  null
  
)

export default component.exports